import React from 'react';
import AvatarList from '../../../../../components/UsersInvited';
import moment from 'moment';
import ArrowBack from '@material-ui/icons/ArrowBack';

//Milan Andrejic
import styled from 'styled-components';

const ArrowWrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
  &:first-child {
    cursor: pointer;
  }
`;
const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  color: white;
`;
const ProjectInfoWrapper = styled.div`
  margin-left: 1rem;
`;

function SubHeaderTickets(props) {
  let creator = props.allUsers.find(user => user.userId === props.creator);
  let user = props.users.find(user => user.userId === props.creator);

  return (
    <div className="sub-header -tickets">
      <div className="sub-header-wrapper">
        <div className="sub-header-content u-pad-r-20">
          <TitleWrapper>
            <ArrowWrapper>
              <ArrowBack onClick={() => props.history.push('/demand')} />
            </ArrowWrapper>
            <ProjectInfoWrapper>
              <h2 className="t_primary-24 u-mrg-bot-5">
                {props.project ? props.project.name : ''}
              </h2>
              <div>
                {props.project && props.project.confidential && (
                  <div className="project-card-project-indicator bc-red" />
                )}
                <b className="t-secondary-14">
                  Project number:
                  {props.project ? props.project.uniqueProjectNumber : ''}
                </b>
              </div>
            </ProjectInfoWrapper>
          </TitleWrapper>
        </div>
        <div className="sub-header-content t-align-r">
          {props.currentUser === props.creator ? (
            <AvatarList
              allUsers={props.allUsers}
              handleOpenShareDialog={props.handleOpenShareDialog}
              projectId={props.project ? props.project.id : 0}
            />
          ) : null}

          <p className="t-secondary-14 u-mrg-bot-5">
            <b>Created by:</b>{' '}
            {user ? user.firstName + ' ' + user.lastName : ''},{' '}
            {user ? user.workRole : ''},{' '}
            {user ? user.regions[0].replace(/_/g, ' ') : ''}
          </p>
          <p className="t-secondary-14">
            <b>Creation date: </b>
            {props.project ? moment(props.created).format('MMM Do YYYY') : ''}
          </p>
        </div>
      </div>
    </div>
  );
}

export default SubHeaderTickets;
